import { useState } from 'react';
import { useRoute, useLocation } from 'wouter';
import { ArrowLeft, Plus, UserPlus, Users } from 'lucide-react';
import { AppShell } from '@/components/app-shell';
import { CustomerList } from '@/components/customer-list';
import { CustomerDetail } from '@/components/customer-detail';
import { NewCustomerModal } from '@/components/new-customer-modal';
import { NewRfqModal } from '@/components/new-rfq-modal';

export function CustomersPage() {
  const [match, params] = useRoute('/customers/:publicId');
  const selectedCustomerId = match ? params.publicId : null;
  const [, setLocation] = useLocation();

  const [newCustomerOpen, setNewCustomerOpen] = useState(false);
  const [newRfqOpen, setNewRfqOpen] = useState(false);

  return (
    <AppShell
      title="Customers"
      subtitle="Aviation-broker CRM — RFQ history, lifetime value, win rate, AOG patterns"
      headerActions={
        <div className="flex items-center gap-2">
          {selectedCustomerId && (
            <button
              onClick={() => setLocation('/customers')}
              className="lg:hidden btn-ghost px-2"
              aria-label="Back to customer list"
            >
              <ArrowLeft className="w-4 h-4" />
              Back
            </button>
          )}
          <button
            onClick={() => setNewCustomerOpen(true)}
            className="btn-ghost text-xs"
          >
            <UserPlus className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">Add customer</span>
          </button>
          <button
            onClick={() => setNewRfqOpen(true)}
            className="btn-primary text-xs"
          >
            <Plus className="w-3.5 h-3.5" />
            New RFQ
          </button>
        </div>
      }
    >
      <div className="h-full lg:grid lg:grid-cols-[minmax(360px,40%)_1fr] overflow-hidden">
        <aside
          className={`h-full border-r border-border overflow-hidden bg-surface ${
            selectedCustomerId ? 'hidden lg:block' : 'block'
          }`}
        >
          <CustomerList selectedCustomerId={selectedCustomerId} />
        </aside>
        <section
          className={`h-full overflow-hidden bg-surface ${
            selectedCustomerId ? 'block' : 'hidden lg:block'
          }`}
        >
          {selectedCustomerId ? (
            <CustomerDetail key={selectedCustomerId} publicId={selectedCustomerId} />
          ) : (
            <div className="h-full flex items-center justify-center px-8">
              <div className="text-center max-w-md">
                <div className="w-12 h-12 mx-auto rounded-full bg-primary-muted text-primary-strong flex items-center justify-center mb-3">
                  <Users className="w-6 h-6" />
                </div>
                <p className="text-sm text-foreground-muted">
                  Select a customer on the left to see their RFQ history, lifetime value, and aviation-specific
                  patterns.
                  <br />
                  <span className="text-xs">
                    Customers auto-populate as RFQs come in (web forms, parsed emails, etc.) — or use the
                    "New RFQ" / "Add customer" buttons above for manual entry.
                  </span>
                </p>
              </div>
            </div>
          )}
        </section>
      </div>

      <NewCustomerModal
        open={newCustomerOpen}
        onClose={() => setNewCustomerOpen(false)}
      />
      <NewRfqModal
        open={newRfqOpen}
        onClose={() => setNewRfqOpen(false)}
      />
    </AppShell>
  );
}
